import { RateCoreEffects } from '@ruby/modules/rate-inquiry/store/effects/rate-core.effects';
import { RateFormEffects } from '@ruby/modules/rate-inquiry/store/effects/rate-form.effects';

export const effects = [
  RateFormEffects,
  RateCoreEffects
];
